import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 4C5 2.89543 5.89543 2 7 2H19.7574C20.2878 2 20.7965 2.21071 21.1716 2.58579L26.4142 7.82843C26.7893 8.2035 27 8.71221 27 9.24264V28C27 29.1046 26.1046 30 25 30H7C5.89543 30 5 29.1046 5 28V4Z"
        stroke="#0090FF"
        strokeWidth="2"
      />
      <g opacity="0.5">
        <path
          d="M18.4993 12.5C18.4993 14.7477 16.847 15.7 15.9993 15.7C15.1516 15.7 13.4993 14.7477 13.4993 12.5C13.4993 11.1193 14.6186 10 15.9993 10C17.38 10 18.4993 11.1193 18.4993 12.5Z"
          stroke="#0090FF"
          strokeWidth="2"
        />
        <path
          d="M10 22.3498C10 21.0827 10.7781 20.0097 11.9079 19.6994C13.2591 19.3284 14.8088 19 16 19C17.1912 19 18.7409 19.3284 20.0921 19.6994C21.2219 20.0097 22 21.0827 22 22.3498V23.3L10 23.3L10 22.3498Z"
          stroke="#0090FF"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export default Svg;
